export { UserTermsPage as default } from "@nvb/ui";
